var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.link)?_c('a',{class:['badge badge-pill', _vm.styles],attrs:{"href":_vm.incidentLink}},[_vm._v(_vm._s(_vm.type))]):_c('span',{class:['badge badge-pill', _vm.styles]},[_vm._v(_vm._s(_vm.type))])}
var staticRenderFns = []

export { render, staticRenderFns }